const pageEnLang = {
  // country page
  countryPage_countries: 'Countries',
  countryPage_countryName: 'Country name',
  countryPage_noOfGsmOperators: 'No of GSM operators',
  countryPage_nationalNumLength: 'National number length',
  countryPage_internationalCountryCode: 'Country code',
  countryPage_alphaCode: 'Alpha code',
  countryPage_timeZoneId: 'TimeZone',
  countryPage_CreateCountry: 'Create country',
  countryPage_UpdateCountry: 'Update country',
  countryPage_UpdateCountry_IsOperating: 'Is Operating',
  // update profile
  updateProfile_title: 'Update profile',
  updateProfile_FirstName: 'First name',
  updateProfile_LastName: 'Last name',
  updateProfile_Email: 'Email',
  updateProfile_Phone: 'Phone',
  // update password
  updatePassword_Title: 'Change password',
  updatePassword_ChangePasswordSuccess: 'Change Password Success',
  updatePassword_CurrentPassword: 'Current password',
  updatePassword_NewPassword: 'New password',
  updatePassword_ConfirmPassword: 'Confirm password',
  updatePassword_PasswordNotMatch: 'The password entered does not match',
  // email template
  emailTemplate_Title: 'Email Templates',
  emailTemplate_CreateEmailTemplate: 'Create Email Template',
  emailTemplate_UpdateEmailTemplate: 'Update Email Template',
  emailTemplate_NameEmailTemplate: 'Name Email Template',
  emailTemplate_EmailTemplate_ToEmail: 'To email (allow multi emails, separate by)',
  emailTemplate_EmailTemplate_CcEmail: 'Cc email (allow multi emails, separate by)',
  emailTemplate_EmailTemplate_BccEmail: 'Bcc email (allow multi emails, separate by)',
  emailTemplate_EmailTemplate_Subject: 'Subject',
  emailTemplate_Subject: 'Subject',
  emailTemplate_Body: 'Body',
  emailTemplate_NameEmailTemplatePlaceholder: 'Chosen Email Template',
  emailTemplate_Active: 'Active',
  emailTemplate_Attachment: 'Attachment',
  emailTemplate_CultureCode: 'Culture code',
  // regions
  regionPage_title: 'Regions',
  regionPage_Name: 'Name',
  regionPage_Country: 'Country',
  regionPage_CreateRegion: 'Create region',
  regionPage_UpdateRegion: 'Create region',
  // cities
  cityPage_Title: 'Cities',
  cityPage_Name: 'City name',
  cityPage_Code: 'City code',
  cityPage_Country: 'Country',
  cityPage_Region: 'Region',
  regionPage_CreateCity: 'Create city',
  regionPage_UpdateCity: 'Update city',
  // forgot password
  forgotPasswordPage_TitleForgotPassword: 'Forgot password',
  forgotPasswordPage_EmailAddress: 'Please input your email',
  forgotPasswordPage_Submit: 'Submit',
  forgotPasswordPage_BackToLoginPage: 'Back to login page',
  forgotPasswordPage_ForgotPasswordSuccess: `We has sent an email to <b>{{email}}</b> requesting a password reset!
                                            <br/>Please click on the link within 30 minutes.
                                            <br/>Or you will need to request a new link.
                                            <br/>If you do not see the email, please check your spam folder. `,
  forgotPasswordPage_ForgotPassword_Hint: `A URL to reset your password will be sent to you.
                                            <br />Please enter your registered e-mail address and click the "Submit" button. `,

  //reset password
  resetPasswordPage_TitleResetPassword: 'Reset password',
  resetPasswordPage_TitleHint: 'Please set a new password.',
  resetPasswordPage_ForgotPasswordSessionExpired: 'Forgot Password session has expired',
  resetPasswordPage_ResetPasswordSuccess: 'Reset password success',
  //confirm email
  confirmEmailPage_Title: 'Email address confirmation',
  confirmEmailPage_Success: 'Your email address is confirmed. You can now sign in.',
  confirmEmailPage_Invalid: 'This confirmation link is invalid or has expired.',
  // select entity
  selectEntityPage_Title: 'Select entity',
  selectEntityPage_Operations: 'Operations',
  selectEntityPage_Operations_SubTitle: 'Manage Your Operations',
  selectEntityPage_Configurations: 'Configurations',
  selectEntityPage_Configurations_SubTitle: 'Setup Configurations',
  selectEntityPage_Monitoring: 'Monitoring',
  selectEntityPage_Monitoring_SubTitle: 'System Monitoring',
  selectEntityPage_PassengerAppConfigurations: 'Passenger App',
  selectEntityPage_PassengerAppConfiguration_SubTitle: 'Passenger App Configurations',
  // admin users
  adminUsersPage_Title: 'Admin users',
  adminUsersPage_Username: 'User name',
  adminUsersPage_Email: 'Email',
  adminUsersPage_FullName: 'Full name',
  adminUsersPage_Phone: 'Phone',
  adminUsersPage_emailConfirmed: 'Email confirmed',
  adminUsersPage_LastLogin: 'Last login',
  adminUsersPage_IsBlackListed: 'Is black listed',
  adminUsersPage_SearchText: 'Name, email, phone...',
  adminUsersPage_Roles: 'Roles',
  adminUsersPage_UserRemarks: 'User remarks',
  adminUsersPage_FirstName: 'First name',
  adminUsersPage_LastName: 'Last name',
  adminUsersPage_CreateUser: 'Create user',
  adminUsersPage_UpdateUser: 'Update user',
  adminUsersPage_ReportingManager: 'Reporting manager',
  adminUsersPage_AllUser: 'All users',
  adminUsersPage_ExportUsers: 'Export admin users',
  // access control page
  accessControlPage_Title: 'Access control',
  accessControlPage_Password: 'Password',
  accessControlPage_Requirement: 'Requirement',
  accessControlPage_PasswordLength: 'Minium password length',
  accessControlPage_NoOfUpperCase: 'Number of uppercase',
  accessControlPage_NoOfLowerCase: 'Number of lowercase',
  accessControlPage_NoOfSpecialCharacters: 'Number of special characters',
  accessControlPage_NoOfNumericCharacters: 'Number of numeric characters',
  accessControlPage_PasswordExpirationDays: 'Password expiration (days)',
  accessControlPage_AllowNameCharacters: 'Allow password to contain Last name or First name and their reverse orders',
  accessControlPage_PreventPasswordReuse: 'Prevent Password reuse',
  accessControlPage_UpdateSucessMessage: 'Update successfull',
  accessControlPage_2faSubtitle: 'Two Factor Authentication',
  accessControlPage_2faGlobalUser: 'Enable two factor authentication for global users',
  accessControlPage_2faCompanyUser: 'Enable two factor authentication for company users',
  // login page
  loginPage_2FaAuthentication: 'Two-Factor Authentication',
  loginPage_YourVerifycationCode: 'Your verification code',
  loginPage_ReSendCode: 'Resend verification code',
  loginPage_Verify: 'Verify',
  loginPage_ChangeProvider: 'Select other provider',
  loginPage_PleaseSelectProvider: 'Please select provider to receive a verification code',
  loginPage_Email: 'Email',
  loginPage_EmailSubTitle: ` A verification code will be sent to email <b>{{email}}</b>`,
  loginPage_PhoneNumber: 'Phone number',
  loginPage_PhoneSubTitle: 'A verification code will be sent to your phone number <b>{{phone}}</b>',
  loginPage_Send: 'Send',
  loginPage_AuthenticatorTitle: 'Authenticator app',
  loginPage_AuthenticatorRequired:
    'Your account requires an authenticator app (Google Authenticator, Microsoft Authenticator…). Set it up now: email and SMS codes then remain available as a backup.',
  loginPage_AuthenticatorStart: 'Set up the authenticator app',
  loginPage_AuthenticatorScan: 'Scan this QR code with your authenticator app, then enter the 6-digit code it shows.',
  loginPage_AuthenticatorManualKey: 'Or enter this key manually:',
  loginPage_AuthenticatorCodeHint: 'Enter the 6-digit code shown in your authenticator app.',
  loginPage_RecoveryCodeHint: 'Enter one of your recovery codes. Each code can be used only once.',
  loginPage_RecoveryCodesHint:
    'Keep these recovery codes in a safe place: they let you sign in if you lose your phone. They will not be shown again.',
  loginPage_UseAuthenticator: 'Use the authenticator app',
  loginPage_UseRecoveryCode: 'Use a recovery code',
  loginPage_Continue: 'Continue',
  loginPage_Later: 'Later',
  loginPage_CodeHasSend2Email: `A verification code has been sent to email <b>{{email}}</b>`,
  loginPage_CodeHasSend2Phone: `A verification code has been sent to your phone number <b>{{phone}}</b>`,

  // partner
  partnerPage_Title: 'Partners',
  partnerPage_MNOS: 'MNOS',
  partnerPage_Bank: 'Bank',
  partnerPage_Utility: 'Utility',
  partnerPage_Name: 'Name',
  partnerPage_TechnicalPhoneNumber: 'Technical phone mumber',
  partnerPage_TechnicalSupportEmail: 'Technical support email',
  partnerPage_ConnectivityDetails: 'Connectivity details',
  partnerPage_CreatePartner: 'Create partner',
  partnerPage_UpdatePartner: 'Update partner',
  partnerPage_ContactEmail: 'Contact email',
  partnerPage_MonetaryZone: 'Monetary zone',
  partnerPage_SearchText: 'Partner name, phone number...',
  partnerPage_PartnerAccount: 'Utility partner account',
  partnerPage_CreateUtilityPartner: 'Create utility partner account',
  partnerPage_UpdateUtilityPartner: 'Update utility partner account',
  partnerPage_UtilityConnectivityDetails: 'Utility partner connectivity details',
  partnerPage_UpdateUtilityConnectivityDetails: 'Update utility partner connectivity details',
  partnerPage_CreateUtilityConnectivityDetails: 'Create utility partner connectivity details',
  partnerPage_Bank_OperatorName: 'Bank/Operator Name',
  partnerPage_AccountType: 'Account type',
  partnerPage_AccountOwner: 'Account owner',
  partnerPage_AccountNumber: 'Account number',
  partnerPage_UtilityPartnerAccounts: 'Utility partner accounts',
  partnerPage_CreateUtilityPartnerAccount: 'Create utility partner account',
  partnerPage_UpdateUtilityPartnerAccount: 'Update utility partner account',
  passengerPage_ExportUtilityPartners: 'Export utility partners',
  passengerPage_ExportPaymentPartner: 'Export payment partners',
  partnerPage_LogoImage: 'Logo image',
  // company page
  companyPage_Title: 'Companies',
  companyPage_SearchText: 'Company name, phone number...',
  companyPage_CompanyName: 'Name',
  companyPage_PlanName: 'Plan',
  companyPage_NoOfStations: 'No Of Stations',
  companyPage_CityRegionCountry: 'City, Region, Country',
  companyPage_EmployeeNo: 'Employee No',
  companyPage_SMS_Email_NotificationAllow: 'Notification',
  companyPage_ExportCompanies: 'Export companies',
  companyPage_IsApproved: 'Is Approved',
  companyPage_InActiveTicketSelling: 'Set inactive ticket selling',
  companyPage_ActiveTicketSelling: 'Set active ticket selling',

  // passenger page
  passengerPage_Title: 'Passengers',
  passengerPage__SearchText: 'Emai, full name, phone number...',
  passengerPage_IsTicketBookingAllowed: 'Is ticket booking allowed',
  passengerPage_ExportPassengers: 'Export passengers',
  // service page
  servicePages_Title: 'Services',
  servicePages_SearchText: 'Service name',
  servicePages_ServiceName: 'Service name',
  servicePages_ActivationDate: 'Activation date',
  servicePages_AvailableApps: 'Available apps',
  servicePages_MasterServiceType: 'Link to master service',
  servicePages_FeePayingEntities: 'Fee Paying Entities',
  servicePages_FeeSharingEntities: 'Fee Sharing Entities',
  servicePages_IsPercentageBase: 'Is percentage base',
  servicePages_Customer: 'Customer',
  servicePages_Rate: 'Rate',
  servicePages_Merchant: 'Merchant',
  servicePages_MonektoUsers: 'Monekto Users',
  servicePages_TransportCompanies: 'Transport companies',
  servicePages_Mtopo: 'Mtopo',
  servicePages_Operators: 'Operators',
  servicePages_CreateService: 'Create service',
  servicePages_UpdateService: 'Update service',
  // software Components page
  softwareComponentsPage_ComponentName: 'Component name',
  softwareComponentsPage_ComponentType: 'Component type',
  softwareComponentsPage_Price: 'Price',
  softwareComponentsPage_AvailableApps: 'Available apps',
  softwareComponentsPage_Title: 'Software components',
  // plan page
  planPage_Title: 'Plans',
  planPage_SearchText: 'Plan name...',
  planPage_PlanName: 'Plan name',
  planPage_NoOfRegister: 'No of register',
  planPage_TransactionLimit: 'Transaction limit',
  planPage_Turnover: 'Turnover',
  planPage_MonthlyFee: 'Monthly fee',
  planPage_PaymentTerm: 'Payment term',
  planPage_PaymentMethodType: 'Payment method',
  planPage_PlanType: 'Plan type',
  planPage_IsPopular: 'Is popular',
  planPage_Components: 'Components',
  planPage_AvailableApps: 'Available apps',
  planPage_TransactionFee: 'Transaction fee',
  planPage_Services: 'Services',
  planPage_CreatePlan: 'Create plan',
  planPage_UpdatePlan: 'Update plan',
  // passengerDiscount page
  passengerDiscountPage_Title: 'Passenger App Discounts',
  passengerDiscountPage_PromoCode: 'Promo Code',
  passengerDiscountPage_AutoApply: 'Auto Apply',
  passengerDiscountPage_RefNo: 'Ref No',
  passengerDiscountPage_ShortDescription: 'Short Description',
  passengerDiscountPage_MaxDiscountAmount: 'Max Discount Amount',

  passengerDiscountPage_ApplicationTarget: 'Application Target',
  passengerDiscountPage_PromoPhotoUrl: 'Promo Image',
  passengerDiscountPage_Company: 'Company',
  passengerDiscountPage_SelectCompany: 'Select companies',

  passengerDiscountPage_DiscountUsage: 'Discount Usage',
  passengerDiscountPage_NoOfApplyTimes: 'No of Apply Times',
  passengerDiscountPage_DiscountUser: 'Discount User',
  passengerDiscountPage_NewUserAfterDate: 'New User After Date',
  passengerDiscountPage_OldUserBeforeDate: 'Old User Before Date',
  passengerDiscountPage_SelectUsers: 'Select users',
  // passenger booking page
  passengerBookingPage_Title: 'Passenger App Bookings',
  passengerBookingPage_TotalAmount: 'Amount',
  passengerBookingPage_PayMode: 'Pay Mode',
  // passenger app settings

  passengerSettingPage_Title: 'Passenger App Settings',
  passengerBookingPage_ConfirmationBookingNotification: 'Confirmation Booking Notification',

  sellOnTheGoReconciliation_PageTitle: 'Sell On The Go Reconciliations',
  sellOnTheGoReconciliation_SelectDriverOrCoDriver: 'Select driver or co-driver',
  sellOnTheGoReconciliation_TotalBookingAmount: 'Total booking amount',
  sellOnTheGoReconciliation_DeclaredAmount: 'Declared amount',
  sellOnTheGoReconciliation_ExpectedAmount: 'Expected amount at fare',
  sellOnTheGoReconciliation_AmountGap: 'Gap',

  // passenger app - users
  passengerAppUser_Title: 'Manage Prisme Users',
  passengerAppUser_RegisterSource: 'Register source',
  passengerAppUser_PhoneNumberConfirmed: 'Phone number confirmed',
  passengerAppUser_PhoneNumber: 'Phone number',
  passengerAppUser_IsActive: 'Is active',
  passengerAppUser_RegisterDate: 'Register date',
  passengerAppUser_WalletBlocked: 'Wallet blocked',
  passengerAppUser_ShowPassengerInfo: 'Show passenger info',
  passengerAppUser_BlockPassengerWalletConfirm: 'Are you sure you want to change user wallet permission for this user ?',
  passengerAppUser_BlockWallet: 'Block wallet',
  passengerAppUser_UnBlockWallet: 'Unblock wallet',
  passengerAppUser_EmailConfirmed: 'Email confirmed',
  passengerAppUser_UserFollowupsDetails: 'User Followups Details',
  passengerAppUser_Comment: 'Comment',
  passengerAppUser_FollowUpDateTime: 'FollowUp Date',
  passengerAppUser_NextFollowUpDateTime: 'Next FollowUp Date',
  passengerAppUser_FollowUpType: 'FollowUp Type',
  passengerAppUser_CreateNew: 'Create new',
  passengerAppUser_Update: 'Update',
};

export default pageEnLang;
